import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {userConferencesStateSelector} from './user-conferences-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountPrimaryManager} from 'src/openapi/admin/models/AccountPrimaryManager';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const userConferencePrimaryManagerSlice = getCachedTableDataSlice<
    Record<string, AccountPrimaryManager>,
    AccountSearchCriteria,
    AccountSortField,
    undefined
>('userConferencesPrimaryManager');

export const userConferencesPrimaryManagerActions = userConferencePrimaryManagerSlice.actions;

const userConferencesPrimaryManagerCacheSelector: CachedTableCacheSelector<Record<string, AccountPrimaryManager>>
    = state => state.userPage.tabs.userConferences.primaryManager.cache;
export const userConferencesPrimaryManagerDataSelector: CachedTableDataSelector<
    Record<string, AccountPrimaryManager>
> = state => state.userPage.tabs.userConferences.primaryManager;
export const userConferencesPrimaryManagerResultSelector = getCachedTableResultSelector(
    userConferencesPrimaryManagerCacheSelector,
    userConferencesStateSelector,
);
